<template>
    <div class="animated fadeIn lapeks-page">
        <div class="filter-card mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h4 class="page-title mb-0">Laporan Penjualan</h4>
                <button type="button" class="btn btn-filter-reset" name="downloadExcelBtn" :disabled="isLoading" @click="confirmLaporanDownload()">
                    <i class="fa fa-download mr-2"></i>Download Excel
                </button>
            </div>

            <div class="filter-section">
                <div class="filter-controls-row">
                    <div class="filter-field">
                        <span class="filter-sublabel">Cabang</span>
                        <div class="filter-multiselect-wrapper">
                            <multiselect
                                name="filterCabang"
                                v-model="input.filterCabang"
                                :options="cabangOption"
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="Cabang"
                                :disabled="!showWebPeriode"
                                @input="onCabangChange"
                            />
                        </div>
                    </div>

                    <div class="filter-field">
                        <span class="filter-sublabel">Periode</span>
                        <div class="range-group">
                            <b-form-select v-model="input.bulan" id="inputBulan" name="inputBulan" :options="optionBulan" class="filter-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" :options="optionTahun" class="filter-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>

                    <button type="button" class="btn btn-filter-search" name="searchTableBtn" :disabled="isLoading" @click="onSearch()">
                        <i class="fa fa-search"></i>
                    </button>
                    <button type="button" class="btn btn-filter-reset" name="resetTableBtn" :disabled="isLoading || !showWebPeriode" @click="onResetAll()">Reset</button>
                </div>
            </div>
        </div>

        <div v-if="showWebPeriode">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h6>
                            Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePinjaman" label="Tipe Pinjaman">
                        <b-form-select class="ml-2" v-model="input.tipePinjamanLaporan" name="tipePinjamanLaporan" :options="tipePinjamanOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-shopping-bag"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Unit</p>
                                    <strong class="mb-0">{{$helper.addThousandSeparator(showDataPenjualanAll.unit)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-calculator"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Modal</p>
                                    <strong class="mb-0">Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.modal)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Harga Jual</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.hargaJual)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-dollar"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Laba</p>
                                    <strong class="mb-0" v-if="showDataPenjualanAll.margin == null">{{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                    <strong class="mb-0" v-else-if="showDataPenjualanAll.margin < 0">- Rp{{$helper.addThousandSeparator(showDataPenjualanAll.margin).replace("-", "")}}</strong>
                                    <strong class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="table-card">
                    <div class="table-responsive-wrapper">
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataPenjualan" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data penjualan.
                        </template>
                        <template v-slot:cell(unit)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unit) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modal)="row">
                            <div class="text-right no-wrap" v-if="row.item.modal == null">{{$helper.addThousandSeparator(row.item.modal)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.modal < 0">- Rp{{$helper.addThousandSeparator(row.item.modal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modal)}} </div>
                        </template>
                        <template v-slot:cell(hargaJual)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.hargaJual == null">{{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                                <p class="mb-0" v-else-if="row.item.hargaJual < 0">- Rp{{$helper.addThousandSeparator(row.item.hargaJual).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                            </div>
                        </template>
                        <template v-slot:cell(margin)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.margin == null">{{$helper.addThousandSeparator(row.item.margin)}} </p>
                                <p class="mb-0" v-else-if="row.item.margin < 0">- Rp{{$helper.addThousandSeparator(row.item.margin).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.margin)}} </p>
                            </div>
                        </template>
                    </b-table>
                    </div>

                    <div class="table-pagination-footer d-flex align-items-center justify-content-between">
                        <div class="limit-wrapper d-flex align-items-center">
                            <span class="limit-label mr-2">Tampilkan</span>
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options" class="limit-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="entries-info ml-3">{{ totalViewText }}</span>
                        </div>
                        <b-pagination class="custom-pagination mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                            prev-text="‹"
                            next-text="›"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>

                </div>
            </div>
        </div>

        <!--
            ============================================================
            VARIAN "LAPORAN TAHUNAN" - dinonaktifkan.
            Referensi hanya menampilkan tabel per-cabang, jadi blok ini
            dimatikan lewat v-if="false" (bukan komentar HTML, karena
            markup di dalamnya memuat "--" yang menutup komentar).
            Kode tetap utuh bila nanti mau diaktifkan lagi.
            ============================================================
        -->
        <div v-if="false">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Penjualan</h4>
                        <h6>
                            Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePinjaman" label="Tipe Pinjaman">
                        <b-form-select class="ml-2" v-model="input.tipePinjamanLaporan" name="tipePinjamanLaporan" :options="tipePinjamanOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-shopping-bag"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Unit</p>
                                    <strong class="mb-0">{{$helper.addThousandSeparator(showDataPenjualanAll.unit)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-calculator"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Modal</p>
                                    <strong class="mb-0">Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.modal)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Harga Jual</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.hargaJual)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-dollar"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Laba</p>
                                    <strong class="mb-0" v-if="showDataPenjualanAll.margin == null">{{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                    <strong class="mb-0" v-else-if="showDataPenjualanAll.margin < 0">- Rp{{$helper.addThousandSeparator(showDataPenjualanAll.margin).replace("-", "")}}</strong>
                                    <strong class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan Penjualan</h5>
                    </template>
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataPenjualan" 
                        :fields="fieldTahunan" 
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data penjualan.
                        </template>
                        <!-- <template v-slot:thead-top>
                            <b-tr>
                                <b-th># </b-th>
                                <b-th colspan="3">Elektronik</b-th>
                                <b-th colspan="3">BPKB & Kendaraan</b-th>
                            </b-tr>
                        </template> -->
                        <template v-slot:cell(unit)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unit) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modal)="row">
                            <div class="text-right no-wrap" v-if="row.item.modal == null">{{$helper.addThousandSeparator(row.item.modal)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.modal < 0">- Rp{{$helper.addThousandSeparator(row.item.modal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modal)}} </div>
                        </template>
                        <template v-slot:cell(hargaJual)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.hargaJual == null">{{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                                <p class="mb-0" v-else-if="row.item.hargaJual < 0">- Rp{{$helper.addThousandSeparator(row.item.hargaJual).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                            </div>
                        </template>
                        <template v-slot:cell(margin)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.margin == null">{{$helper.addThousandSeparator(row.item.margin)}} </p>
                                <p class="mb-0" v-else-if="row.item.margin < 0">- Rp{{$helper.addThousandSeparator(row.item.margin).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.margin)}} </p>
                            </div>
                        </template>
                    </b-table>

                </b-card>
            </div>
        </div>
        <b-modal id="modal-web-password" content-class="lapeks-modal" @shown="focusLaporanWebPassword" title="Confirm Web Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openLaporanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordWeb"
                        v-model="input.passwordWeb"
                        name="passwordWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-password" content-class="lapeks-modal" @shown="focusLaporanDownloadPassword" title="Confirm Download Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openLaporanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordDownload"
                        v-model="input.passwordDownload"
                        name="passwordDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" content-class="lapeks-modal" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'laporan-penjualan',
    data(){
        return{
            isSubmitting: false,
            input:{
                bulan: 0,
                tahun: 2020,
                passwordDownload: "",
                passwordWeb: "",
                //
                show: 10,
                filterCabang: null,
                tipePinjamanLaporan: 1,
            },
            tipePinjamanOption: [
                {id: 1, name: 'Elektronik'},
                {id: 2, name: 'BPKB'},
                {id: 3, name: 'Kendaraan'}
            ],
            optionTahun: [],
            optionBulan: [
                { value: "0", text: "-" },
                { value: "1", text: "Januari" },
                { value: "2", text: "Februari" },
                { value: "3", text: "Maret" },
                { value: "4", text: "April" },
                { value: "5", text: "Mei" },
                { value: "6", text: "Juni" },
                { value: "7", text: "Juli" },
                { value: "8", text: "Agustus" },
                { value: "9", text: "September" },
                { value: "10", text: "Oktober" },
                { value: "11", text: "November" },
                { value: "12", text: "Desember" }
            ],
            
            isLoading: false,
            filePathDownload: "",
            query: "",

            showWebPeriode: false,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',

            //
            showWebTahunan: false,
            periodeBulan: '',
            periodeTahun: '',
            isBusy: true,
            fields: [
                { key: "cabangName", label: "Cabang" },
                { key: "unit", label: "Unit", sortable: true },
                { key: "modal", label: "Modal", sortable: true },
                { key: "hargaJual", label: "Nilai Jual", sortable: true },
                { key: "margin", label: "Laba", sortable: true },
            ],
            fieldTahunan: [
                { key: "cabangName", label: "Bulan" },
                { key: "unit", label: "Unit", sortable: true },
                { key: "modal", label: "Modal", sortable: true},
                { key: "hargaJual", label: "Nilai Jual", sortable: true },
                { key: "margin", label: "Laba", sortable: true },
            ],
            dataPenjualan: [],

            dataPenjualanAll : {},
            showDataPenjualanAll : [],
            showDataPenjualan: [],
        }
    }, 
    watch: {
        "input.tipePinjamanLaporan": function(newValue) {
            if(newValue == 1){
                this.showDataPenjualanAll = this.dataPenjualanAll.elek
                this.showDataPenjualan = this.dataPenjualanAll.elek.entries
            }else if(newValue == 2){
                this.showDataPenjualanAll = this.dataPenjualanAll.bpkb
                this.showDataPenjualan = this.dataPenjualanAll.bpkb.entries
            }else{
                this.showDataPenjualanAll = this.dataPenjualanAll.kend
                this.showDataPenjualan = this.dataPenjualanAll.kend.entries
            }
            this.updateTotalItem()
            this.input.filterCabang = null
            this.perPage = 10
            this.currentPage = 1
        },
    },
    methods: {
		init(){
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.optionTahun.push(i)
			}
		},
        focusLaporanWebPassword(){
            this.$refs.passwordWeb.focus()
        },
        focusLaporanDownloadPassword(){
            this.$refs.passwordDownload.focus()
        },

        confirmLaporanDownload(){
            if(this.input.bulan == null || this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanDownload()
                    this.input.passwordDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-download-password')
                }
            }
        },

        openLaporanDownload(){
            this.showWebTahunan = false
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-download-password')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            this.query = `bulan=${this.input.bulan}&tahun=${this.input.tahun}&password=${this.input.passwordDownload}`
            this.$axios.get(`laporan-eksekutif/penjualan/dl?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmLaporanWeb(){
            if(this.input.bulan == null || this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanWeb()
                    this.input.passwordWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-web-password')
                }
            }
        },

        openLaporanWeb(){
            let idx = this.optionBulan.findIndex(item => item.value == this.input.bulan)
            this.periodeBulan = this.optionBulan[idx].text
            this.periodeTahun = this.input.tahun
            console.log(this.periodeBulan)
            if(this.periodeBulan != '-'){
                this.showWebPeriode = true
                this.showWebTahunan = false
            }else{
                this.showWebPeriode = false
                this.showWebTahunan = true
            }
            this.isLoading = true
            this.$bvModal.hide('modal-periode-webPassword')
            this.$bvModal.hide('modal-web-password')
            setTimeout(() => { this.axiosLaporanWeb() }, 500)
        },

        axiosLaporanWeb(){
            let getCabang = this.checkJenisLaporan()

            let getDataPenjualan = this.$axios.get(`laporan-eksekutif/penjualan?bulan=${this.input.bulan}&tahun=${this.input.tahun}&password=${this.input.passwordWeb}`).then(response => {
                this.dataPenjualanAll = response.data
                this.showDataPenjualanAll = response.data.elek
                this.showDataPenjualan = response.data.elek.entries
                this.input.tipePinjamanLaporan = 1
                this.updateTotalItem()
                this.perPage = 10
                this.currentPage = 1
                console.log(response.data)
            })

            Promise.all([getCabang, getDataPenjualan]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordWeb = ""
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordWeb = ""
                this.showWebTahunan = false
                this.showWebPeriode = false
                this.isLoading = false
            })
        },

        checkJenisLaporan(){
            if(this.periodeBulan != '-'){
                if(this.cabangOption.length == 0){
                    this.$axios.get("cabang/all-selection").then(response => {
                        response.data.forEach((element) => {
                            if(element.id != this.srcCabangId)
                                this.cabangOption.push(element)
                        })
                    })
                }
            }else{
                this.cabangOption = []
            }
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataPenjualan(){
            this.showDataPenjualan = this.showDataPenjualanAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Aksi baris filter -----------------

        // Bulan & tahun diproses server, jadi Search mengambil ulang data.
        // Password diminta sekali, setelahnya dipakai ulang dari localStorage.
        onSearch(){
            this.confirmLaporanWeb()
        },

        // Filter cabang murni sisi klien, langsung berlaku.
        onCabangChange(){
            if(!this.showWebPeriode) return
            if(this.input.filterCabang == null){
                this.onReset()
            }else{
                this.onFilter()
            }
        },

        onResetAll(){
            this.input.filterCabang = null
            this.onReset()
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataPenjualan()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.showDataPenjualanAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.showDataPenjualan = filteredArray
                this.onFiltered(this.showDataPenjualan)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.showDataPenjualan.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

	},
	created(){
        this.init()
    }
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.lapeks-page { padding-bottom: 30px; }

.filter-card,
.table-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card { padding: 22px 24px 24px; }
.table-card  { padding: 0; overflow: hidden; margin-bottom: 16px; }

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Label varian laporan di dalam kartu tabel
.table-card-label {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding: 18px 20px 12px 32px;
    margin: 0;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 19px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

// Filter
.filter-section {
    .filter-controls-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .filter-sublabel {
        font-size: 11.5px;
        font-weight: 600;
        color: $ink-body;
    }

    .range-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .range-sep { font-size: 12px; color: $ink-muted; flex-shrink: 0; }

    ::v-deep .filter-input,
    .filter-select {
        height: 38px;
        border-radius: 8px;
        border: 1px solid $input-border;
        font-size: 13px;
        color: $ink-body;
        padding: 6px 14px;
        background-color: #FFFFFF;

        &::placeholder { color: #8C9F98; font-size: 12.5px; }

        &:focus {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            outline: none;
        }
    }

    ::v-deep .filter-input.input-days { width: 110px; }
    .filter-select { padding: 6px 12px; width: 180px; max-width: 100%; }

    .filter-multiselect-wrapper {
        width: 220px;
        max-width: 100%;

        ::v-deep .multiselect {
            min-height: 38px;

            .multiselect__tags {
                min-height: 38px;
                height: 38px;
                padding: 6px 30px 0 12px;
                border-radius: 8px;
                border: 1px solid $input-border;
                background: #FFFFFF;
                font-size: 13px;
                color: $ink-body;
            }

            .multiselect__placeholder {
                margin-bottom: 0;
                padding-top: 2px;
                color: #8C9F98;
                font-size: 12.5px;
            }

            .multiselect__single {
                margin-bottom: 0;
                padding-top: 2px;
                font-size: 13px;
                color: $ink-body;
                line-height: 20px;
            }

            .multiselect__select { height: 36px; width: 32px; padding: 4px 6px; }

            &.multiselect--active .multiselect__tags {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            }
        }
    }
}

.btn-filter-search {
    width: 40px;
    height: 38px;
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: $deep-pine-hover; border-color: $deep-pine-hover; }
    &:disabled { opacity: 0.7; cursor: not-allowed; }
}

.btn-filter-reset {
    height: 38px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    font-size: 12.5px;
    font-weight: 500;
    padding: 6px 18px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
}

.table-responsive-wrapper { overflow-x: auto; }

.custom-data-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: #F6F7F6;
        border-top: none;
        border-bottom: 1px solid #ECEFEC;
        font-size: 11px;
        font-weight: 600;
        color: #7E918B;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 14px 20px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover { background-color: #F8FAF9; }

        td {
            padding: 16px 20px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
            font-size: 13px;
            color: $ink-body;
            font-weight: 500;
        }

        &:first-child td { border-top: none; }
    }
}

.table-pagination-footer {
    border-top: 1px solid #EDF2EF;
    padding: 16px 20px 4px;

    .limit-label { font-size: 12.5px; color: $ink-muted; }

    .limit-select {
        height: 32px;
        width: 70px;
        border-radius: 6px;
        border: 1px solid $input-border;
        font-size: 12.5px;
        color: $ink-body;
        padding: 2px 8px;
        background-color: #FFFFFF;
    }

    .entries-info { font-size: 12px; color: $ink-muted; }
}

.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            box-shadow: none !important;

            &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}

// Tombol Back pada halaman laporan cetak
.btn-back {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 7px 16px;
    transition: all 0.2s ease;

    &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
}
</style>
